export const NAME = 'searchSuggestions';

export const SEARCH_SUGGESTION_TIMEOUT_IN_MS = 60 * 1000; // 1min
